export interface BreadcrumbTitleContextModel {
  breadcrumbTitle: string | undefined;
  changeBreadcrumbTitle: (newBreadcrumbTitle?: string) => void;
}

export const defaultBreadcrumbTitleContext: BreadcrumbTitleContextModel = {
  breadcrumbTitle: undefined,
  changeBreadcrumbTitle: () => {},
};
